import React from "react";

function Organization() {
  return (
    <section id="organization" className="organization-section">
      <h2>Organização</h2>
      <div className="organization-container">
        <div className="organization-column">
          <h3>Comissão Cientifica</h3>
          <ul>
            <li>André Restivo, FEUP / Universidade do Porto</li>
            <li>Fábio Marques, ESTGA / Universidade de Aveiro</li>
            <li>Filipe Araújo, DEI / Universidade de Coimbra</li>
            <li>João Dias, Universidade do Algarve</li>
            <li>João Pereira, Universidade de Évora</li>
            <li>Luís Russo, IST / Universidade de Lisboa</li>
            <li>Margarida Mamede, FCT / Universidade Nova de Lisboa</li>
            <li>Mário Pereira, FCT / Universidade Nova de Lisboa</li>
            <li>Paul Crocker, Universidade da Beira Interior</li>
            <li>Pedro Mariano, ISCTE</li>
            <li>Pedro Ribeiro, FCUP / Universidade do Porto</li>
            <li>Rui Mendes, Universidade do Minho</li>
            <li>Simão Melo de Sousa, Universidade do Algarve</li>
            <li>Vasco Lopes, Universidade da Beira Interior</li>
            <li>Vasco Pedro, Universidade de Évora</li>
          </ul>
        </div>
        <div className="organization-column">
          <h3>Comissão Organizadora</h3>
          <ul>
            <li>Ana Rita Calvão</li>
            <li>Ciro Martins</li>
            <li>Cristina Guardado</li>
            <li>Fábio Marques</li>
            <li>Hélder Gomes</li>
            <li>Mário Rodrigues</li>
            <li>Paulo Augusto</li>
            <li>Paulo Pinto</li>
          </ul>
        </div>
        {/* <div className="organization-column">
          <h3>Voluntários</h3>
          <ul>
            <li></li>
          </ul>
        </div> */}
      </div>
    </section>
  );
}

export default Organization;
